// 應用更新後，下一次啟動需要強制檢查字典版本的旗標
export const FORCE_DICT_CHECK_ON_NEXT_LOAD_KEY = 'forceDictionaryCheckOnNextLoad';
